
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M468.499 107.136h-106.25V85.868c0-23.457-19.06-42.533-42.5-42.533h-127.5c-23.439 0-42.5 19.075-42.5 42.533v21.267H43.5C20.06 107.136 1 126.21 1 149.668v63.799C1 236.925 20.06 256 43.5 256h170v-10.634c0-5.877 4.752-10.633 10.625-10.633h63.75c5.873 0 10.625 4.756 10.625 10.633V256h170.001c23.438 0 42.498-19.075 42.498-42.533v-63.799c0-23.458-19.06-42.532-42.5-42.532zm-148.75 0h-127.5V85.868h127.5v21.268zM505.105 267.474a10.633 10.633 0 00-11.146 1.049c-7.553 5.723-16.352 8.744-25.462 8.744H298.499v31.899c0 5.877-4.752 10.634-10.625 10.634h-63.75c-5.873 0-10.625-4.757-10.625-10.634v-31.899H43.5c-9.11 0-17.909-3.021-25.463-8.744a10.545 10.545 0 00-11.144-1.049A10.633 10.633 0 001 276.997v149.135c0 23.458 19.06 42.533 42.5 42.533h425c23.439 0 42.5-19.074 42.5-42.533V276.997a10.635 10.635 0 00-5.895-9.523z"}})])
          )
        }
      }
    